import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Tamir() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-red-600 transition-colors">Anasayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/hizmetler" className="hover:text-red-600 transition-colors">Hizmetler</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">3D Yazıcı Tamiri</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                3D Yazıcı <span className="text-red-600">Tamir Hizmeti</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Ankara'da 3D yazıcı tamiri konusunda uzman ekibimizle, arızalı cihazlarınızı orijinal performansına kavuşturuyoruz. Hızlı teşhis ve kaliteli tamir hizmeti.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                >
                  Ücretsiz Teklif Al
                </Link>
                <a 
                  href="https://wa.me/903123945635"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                >
                  WhatsApp ile İletişim
                </a>
              </div>
            </div>
            <div className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <img 
                src="https://public.readdy.ai/ai/img_res/687162b5ad2a947f833d288e15eba9ba.jpg"
                alt="3D Yazıcı Tamir Hizmeti"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Service Details */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              3D Yazıcı Tamir Hizmetlerimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Tüm marka ve modellerde profesyonel tamir hizmeti sunuyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-cpu-line",
                title: "Elektronik Arızalar",
                description: "Anakart, motor sürücü, sensör arızalarının tamiri ve değişimi"
              },
              {
                icon: "ri-settings-4-line",
                title: "Mekanik Sorunlar",
                description: "Ekstruder, hotend, yatak seviyeleme ve hareket sistemleri tamiri"
              },
              {
                icon: "ri-temp-hot-line",
                title: "Isıtma Sistemleri",
                description: "Hotend, yatak ısıtıcı ve termostat arızalarının giderilmesi"
              },
              {
                icon: "ri-code-s-slash-line",
                title: "Yazılım Sorunları",
                description: "Firmware güncelleme, konfigürasyon ve yazılım hatalarının çözümü"
              },
              {
                icon: "ri-printer-line",
                title: "Baskı Kalite Sorunları",
                description: "Katman kayması, stringing, warping gibi baskı kalite problemleri"
              },
              {
                icon: "ri-tools-line",
                title: "Genel Bakım",
                description: "Kapsamlı temizlik, yağlama ve performans optimizasyonu"
              }
            ].map((service, index) => (
              <div 
                key={index}
                className={`bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Tamir Sürecimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profesyonel ve sistematik yaklaşımımızla cihazınızı en kısa sürede tamir ediyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              {
                step: "01",
                title: "Ön Değerlendirme",
                description: "Cihazınızın durumunu inceleyip ücretsiz ön değerlendirme yapıyoruz"
              },
              {
                step: "02",
                title: "Detaylı Teşhis",
                description: "Arızanın kaynağını tespit etmek için kapsamlı teknik analiz"
              },
              {
                step: "03",
                title: "Tamir ve Test",
                description: "Orijinal yedek parçalarla tamir ve kapsamlı test işlemleri"
              },
              {
                step: "04",
                title: "Teslim ve Garanti",
                description: "Cihazınızı teslim edip garanti kapsamında hizmet veriyoruz"
              }
            ].map((process, index) => (
              <div 
                key={index}
                className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${400 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                  {process.step}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{process.title}</h3>
                <p className="text-gray-600">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Supported Brands */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Desteklenen Markalar
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Tüm popüler 3D yazıcı markalarında uzman hizmet veriyoruz
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
            {[
              "Creality", "Prusa", "Ultimaker", "Anycubic", "Artillery", "Ender",
              "Bambu Lab", "Flashforge", "Raise3D", "Zortrax", "Makerbot", "Qidi"
            ].map((brand, index) => (
              <div 
                key={index}
                className={`bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${500 + index * 50}ms` }}
              >
                <div className="text-lg font-semibold text-gray-900">{brand}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Sık Sorulan Sorular
            </h2>
            <p className="text-xl text-gray-600">
              3D yazıcı tamiri hakkında merak edilenler
            </p>
          </div>

          <div className="space-y-6">
            {[
              {
                question: "3D yazıcı tamiri ne kadar sürer?",
                answer: "Arızanın türüne göre değişmekle birlikte, çoğu tamir işlemi 24-48 saat içinde tamamlanır. Yedek parça temini gereken durumlarda süre uzayabilir."
              },
              {
                question: "Tamir garantisi var mı?",
                answer: "Evet, tüm tamir işlemlerimizde 3 ay garanti veriyoruz. Aynı arızanın tekrarlanması durumunda ücretsiz müdahale ediyoruz."
              },
              {
                question: "Hangi markaları tamir ediyorsunuz?",
                answer: "Creality, Prusa, Ultimaker, Anycubic, Artillery ve diğer tüm popüler 3D yazıcı markalarında uzman hizmet veriyoruz."
              },
              {
                question: "Tamir ücreti nasıl belirlenir?",
                answer: "Ön değerlendirme ücretsizdir. Tamir ücreti arızanın türü ve gerekli yedek parçalara göre belirlenir. Size önceden bilgi verilir."
              },
              {
                question: "Evde tamir hizmeti veriyor musunuz?",
                answer: "Evet, Ankara genelinde evde tamir hizmeti veriyoruz. Büyük ve taşınması zor cihazlar için ideal bir seçenektir."
              }
            ].map((faq, index) => (
              <div 
                key={index}
                className={`bg-gray-50 rounded-lg p-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${600 + index * 100}ms` }}
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            3D Yazıcınız Arızalı mı?
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Uzman ekibimizle hemen iletişime geçin. Ücretsiz ön değerlendirme ve hızlı tamir hizmeti.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:03123945635"
              className="bg-white text-red-600 hover:bg-red-50 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Hemen Ara
            </a>
            <a 
              href="https://wa.me/903123945635"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-8 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
                <li><Link to="/hizmetler" className="hover:text-white transition-colors">Tüm Hizmetler</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
                <li><a href="#" className="hover:text-white transition-colors">Referanslar</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0541 456 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
